import { render, staticRenderFns } from "./HeaderHistory.vue?vue&type=template&id=7481a004&scoped=true&"
import script from "./HeaderHistory.vue?vue&type=script&lang=js&"
export * from "./HeaderHistory.vue?vue&type=script&lang=js&"
import style0 from "./HeaderHistory.vue?vue&type=style&index=0&id=7481a004&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7481a004",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
